export function GroupEmptyState() {
    return <div data-testid="group-empty-state">Group empty state</div>;
}
